module.exports = __webpack_public_path__ + "media/images/icons/bi-x-circle-fill-f51c9bea80a70c24dc5d42394e93a36d.png";